document.addEventListener("change", function (e) {

  if (!e.target.closest('variant-selects')) return;

  const form = e.target.closest('product-form');
  if (!form) return;

  const variantIdInput = form.querySelector('input[name="id"]');

  const selectedOption = form.querySelector('[name="id"]');

  // Shopify usually updates URL with ?variant=
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId && variantIdInput) {
    variantIdInput.value = variantId;
    variantIdInput.disabled = false;
  }

});

document.addEventListener("DOMContentLoaded", function () {

  const grid = document.getElementById("product-grid");
  if (!grid) return;

  // Mobile default = grid-2
  const defaultView = window.innerWidth <= 768 ? "grid-2" : "grid-4";

  // Get saved view
  let savedView = localStorage.getItem("collectionGridView");

  // Force mobile to always use grid-2
  if (window.innerWidth <= 768) {
    savedView = "grid-2";
    localStorage.setItem("collectionGridView", "grid-2");
  }

  const activeView = savedView || defaultView;

  grid.classList.remove("grid-2", "grid-4", "grid-5");
  grid.classList.add(activeView);

  document.querySelectorAll(".view-btn").forEach(btn => {
    btn.classList.remove("active");

    if (btn.dataset.view === activeView) {
      btn.classList.add("active");
    }
  });

});


document.addEventListener("click", function (e) {

  const btn = e.target.closest(".view-btn");
  if (!btn) return;

  const view = btn.getAttribute("data-view");
  if (!view) return;

  const grid = document.getElementById("product-grid");
  if (!grid) return;

  grid.classList.remove("grid-2", "grid-4", "grid-5");
  grid.classList.add(view);

  document.querySelectorAll(".view-btn").forEach(b => b.classList.remove("active"));
  btn.classList.add("active");

  // Save selected view
  localStorage.setItem("collectionGridView", view);

});


// Handle screen resize
window.addEventListener("resize", function () {

  const grid = document.getElementById("product-grid");
  if (!grid) return;

  if (window.innerWidth <= 768) {

    grid.classList.remove("grid-4", "grid-5");
    grid.classList.add("grid-2");

    localStorage.setItem("collectionGridView", "grid-2");

    document.querySelectorAll(".view-btn").forEach(btn => {
      btn.classList.remove("active");

      if (btn.dataset.view === "grid-2") {
        btn.classList.add("active");
      }
    });
  }

});


document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.complete-with-list');
  const prevBtn = document.querySelector('.cw-prev');
  const nextBtn = document.querySelector('.cw-next');

  if (!slider || !prevBtn || !nextBtn) return;

  const scrollAmount = slider.querySelector('.complete-with-card')?.offsetWidth + 20 || 400;

  nextBtn.addEventListener('click', () => {
    slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
});




document.addEventListener('click', function (e) {
  const btn = e.target.closest('.copy-link-btn');
  if (!btn) return;

  const url = btn.getAttribute('data-copy-url');

  // Original HTML ek hi baar store hoga
  if (!btn.dataset.originalHtml) {
    btn.dataset.originalHtml = btn.innerHTML;
  }

  navigator.clipboard.writeText(url).then(() => {
    // Step 1: Sirf Copied text (SVG hide)
    btn.textContent = 'Copied';

    btn.classList.add('copied');

    // Step 2: Original SVG + content wapas
    setTimeout(() => {
      btn.innerHTML = btn.dataset.originalHtml;
      btn.classList.remove('copied');
    }, 1200);
  });
});






document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".read-more-collection");
  const wrap = document.querySelector(".collection-features");
  const btnWrap = document.querySelector(".collection-readmore-wrap");

  if (!btn || !wrap || !btnWrap) return;

  btn.addEventListener("click", () => {
    const expanded = wrap.classList.toggle("is-expanded");

    btn.textContent = expanded ? "Read less" : "Read more";

    if (expanded) {
      // 🔥 scroll so user sees bottom + button
      btnWrap.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {

  function updateAllSwipers() {
    document.querySelectorAll('.swiper').forEach(el => {
      if (el.swiper) {
        el.swiper.update();
        el.swiper.updateAutoHeight();
      }
    });
  }

  // Read More click
  document.addEventListener('click', e => {
    const btn = e.target.closest('.read-more-collection');
    if (!btn) return;

    // MULTI-STAGE update (important)
    updateAllSwipers();

    setTimeout(updateAllSwipers, 150);
    setTimeout(updateAllSwipers, 350);
    setTimeout(updateAllSwipers, 700);
  });

  // CSS transition end (MOST IMPORTANT)
  document.addEventListener('transitionend', e => {
    if (e.target.closest('.collection-features')) {
      updateAllSwipers();
    }
  });

  // Resize observer (bulletproof)
  const expandWrap = document.querySelector('.collection-features');
  if (expandWrap && 'ResizeObserver' in window) {
    const ro = new ResizeObserver(() => {
      updateAllSwipers();
    });
    ro.observe(expandWrap);
  }

});




document.addEventListener("DOMContentLoaded", function () {
  const search = document.getElementById("blogSearch");
  const topic = document.getElementById("blogTopic");
  const sort = document.getElementById("blogSort");
  const grid = document.getElementById("blogGrid");

  const visibleCount = document.getElementById("visibleCount");
  const totalCount = document.getElementById("totalCount");

  totalCount.innerText = document.querySelectorAll(".blog-item").length;

  function filterArticles() {
    const items = document.querySelectorAll(".blog-item");

    let searchVal = search.value.toLowerCase();
    let topicVal = topic.value;
    let visible = 0;

    items.forEach(item => {
      const title = (item.dataset.title || "").toLowerCase();
      const tags = item.dataset.tags || "";

      const matchSearch = title.includes(searchVal);
      const matchTag = topicVal === "all" || tags.includes(topicVal);

      if (matchSearch && matchTag) {
        item.style.display = "";
        visible++;
      } else {
        item.style.display = "none";
      }
    });

    visibleCount.innerText = visible;
  }

  function sortArticles() {
    const items = Array.from(document.querySelectorAll(".blog-item"));

    items.sort((a, b) => {

      if (sort.value === "new") {
        return Number(b.dataset.date) - Number(a.dataset.date);
      }

      if (sort.value === "old") {
        return Number(a.dataset.date) - Number(b.dataset.date);
      }

      if (sort.value === "az") {
        return (a.dataset.title || "")
          .toLowerCase()
          .localeCompare((b.dataset.title || "").toLowerCase());
      }

      return 0;
    });

    items.forEach(item => grid.appendChild(item));
  }

  search.addEventListener("input", filterArticles);

  topic.addEventListener("change", filterArticles);

  sort.addEventListener("change", () => {
    sortArticles();
    filterArticles();
  });

  // Initial load
  sortArticles();
  filterArticles();
});

document.addEventListener('DOMContentLoaded', function () {

    const sortDropdown = document.getElementById('SortBy');

    if (!sortDropdown) return;

    function sortProducts(sortType) {

        const productGrid = document.getElementById('product-grid');

        if (!productGrid) return;

        const products = Array.from(
            productGrid.querySelectorAll('.collection-product-card')
        );

        const country = window.currentCountry;

        products.sort(function (a, b) {

            let dateA;
            let dateB;

            if (country === 'US') {
                dateA = a.dataset.pubDateUs;
                dateB = b.dataset.pubDateUs;
            } else {
                dateA = a.dataset.pubDate;
                dateB = b.dataset.pubDate;
            }

            dateA = dateA ? new Date(dateA) : new Date(0);
            dateB = dateB ? new Date(dateB) : new Date(0);

            if (sortType === 'created-descending') {
                return dateB - dateA;
            }

            if (sortType === 'created-ascending') {
                return dateA - dateB;
            }

            return 0;
        });

        products.forEach(function (product) {
            productGrid.appendChild(product);
        });
    }

    sortDropdown.addEventListener('change', function () {

        const selectedSort = this.value;

        if (
            selectedSort === 'created-descending' ||
            selectedSort === 'created-ascending'
        ) {

            sortProducts(selectedSort);
        }
    });

    if (sortDropdown.value === 'created-descending') {

        setTimeout(function () {

            sortProducts('created-descending');

        }, 100);
    }

});


jQuery(function () {

    jQuery(".header__toggle-scheme").hover(function () {

        if (jQuery("body").hasClass("light-custom")) {

            jQuery(".theme-tooltip").text("Gelding street at night");

        } else if (jQuery("body").hasClass("dark-custom")) {

            jQuery(".theme-tooltip").text("Gelding street at day");

        }

    });

});




